import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Stats from "../components/Stats";
import Highlights from "../components/Highlights";
import Accolades from "../components/Accolades";
import Gallery from "../components/Gallery";
import Academics from "../components/Academics";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <main className="bg-neutral-950 text-white">
      <Navbar />
      <Hero />
      <About />
      <Stats />
      <Highlights />
      <Accolades />
      <Gallery />
      <Academics />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
